"use client";

import Button from "@/components/design-system/button";
import styles from "./notFound.module.scss";

interface NotFoundProps {
  heading?: string;
  text?: string;
  /** Value of the `data-error-page` hook, so analytics can tell the error pages apart. */
  variant?: string;
}

export default function NotFound({
  heading = "We couldn't find that page.",
  text = "The page may have moved or no longer exists. Try heading back home, or contact Net32 Support if you need help.",
  variant = "not-found",
}: NotFoundProps) {
  return (
    <div className={styles.NotFound}>
      <section className={styles.content} data-error-page={variant}>
        <h1 className={styles.oops}>
          O<span className={styles.oopsAccent}>o</span>ps!
        </h1>
        <p className={styles.heading}>{heading}</p>
        <p className={styles.text}>{text}</p>
        <Button
          variant="primary"
          color="blue"
          size="large"
          text="Contact Support"
          link={{ href: "/contact-us" }}
          showLeftIcon={false}
          showRightIcon={false}
          className={styles.cta}
          data-error-page-contact-support={variant}
        />
      </section>
    </div>
  );
}
